import React from "react";
import { Routes, Route } from "react-router-dom";

// Main pages
import InnovationLab from "./pages/innovationlab";
import Aboutus from "./pages/aboutus";
import WhatWeDo from "./pages/whatwedo";
import Blogs from "./pages/blogs";
import Aiml from "./pages/aiml";
import DataAnalytics from "./pages/dataAnalytics";
import Startup from "./pages/startup";
import FellowShip from "./pages/fellowship";
import Careers from "./pages/careers";
import PageNotFound from "./pages/pagenotfound";
import Contact from "./pages/contact";
import PrivacyPolicy from "./pages/privacypolicy";
import Support from "./pages/support";
import MensSupport from "./pages/menstruationtrackersupport";

// Diabetes app pages
import About from "./pages/about";

import Benefit from "./pages/benefit";
import Howitworks from "./pages/howitworks";
import Faq from "./pages/faq";
import Follow_us from "./pages/followus";

// Tools
import A1CCalculator from "./pages/A1CCalculator";
import AnionGapCalculator from "./pages/AnionGapCalculator";
import BloodSugarConversion from "./pages/BloodSugarConversion";

// Blogs
import Blogsprediabetes from "./pages/blogsprediabetes";
import Blogstype2diabetes from "./pages/blogstype2diabetes";
import BMICalculator from "./pages/BMICalculator";
import BloodGlucoseLog from "./pages/BloodGlucoseLog";
import Type2DiabetesInfo from "./pages/Type2DiabetesInfo";
import PregnancySugarLevelInfo from "./pages/PregnancySugarLevelInfo";

// AI Agent
import DiabetesAISymptomChecker from "./components/DiabetesAISymptomChecker";
import DiabetesAgentMenu from "./components/DiabetesAgentMenu";

const App: React.FC = () => {
  return (
    <Routes>

      {/* Main pages */}
      <Route path="/" element={<Aboutus />} />
      <Route path="/about-us" element={<Aboutus />} />
      <Route path="/innovation-lab" element={<InnovationLab />} />
      <Route path="/services/beginner-course" element={<Aiml />} />
      <Route path="/services/professional-course" element={<DataAnalytics />} />
      <Route path="/services/javatraining" element={<Startup />} />

      {/* Tools */}
      <Route path="/a1c-conversion-calculator" element={<A1CCalculator />} />
      <Route path="/anion-gap-calculation" element={<AnionGapCalculator />} />
      <Route path="/blood-sugar-conversion" element={<BloodSugarConversion />} />

      {/* Diabetes app pages */}
      <Route path="/diabetes-sugar-tracking-app" element={<About />} />
      <Route path="/diabetes-sugar-tracking-app/benefit" element={<Benefit />} />
      <Route path="/diabetes-sugar-tracking-app/about" element={<About />} />
      <Route path="/diabetes-sugar-tracking-app/howitworks" element={<Howitworks />} />
      <Route path="/diabetes-sugar-tracking-app/faq" element={<Faq />} />
      <Route path="/diabetes-sugar-tracking-app/followus" element={<Follow_us />} />

      {/* Blogs */}
      <Route path="/apps-for-prediabetes" element={<Blogsprediabetes />} />
      <Route path="/app-for-type2-diabetes" element={<Blogstype2diabetes />} />
      <Route path="/body-mass-calculation-formula" element={<BMICalculator />} />
      <Route path="/blood-glucose-sheet" element={<BloodGlucoseLog />} />
      <Route path="/type-2-diabetes-patient-info" element={<Type2DiabetesInfo />} />
      <Route path="/gdm-pregnancy" element={<PregnancySugarLevelInfo />} />

      {/* AI Agent */}
      <Route path="/diabetes-agent/symptoms" element={<DiabetesAISymptomChecker />} />

      {/* Misc */}
      <Route path="/internship" element={<FellowShip />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/contact-us" element={<Contact />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/menstruationtracker-support" element={<MensSupport />} />
      <Route path="/diabetes-agent" element={<DiabetesAgentMenu />} />

      

      {/* 404 page */}
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
  );
};

export default App;
